import { NgModule } from '@angular/core';
import { SectorEbitChartComponent } from './sector-ebit-chart/sector-ebit-chart';
import { IonicModule } from 'ionic-angular';
// Charts
import { ChartModule } from 'angular2-highcharts';
import { ChartComponent } from './chart/chart';
import * as highcharts from 'highcharts'; // tslint:disable-line
import { HighchartsStatic } from 'angular2-highcharts/dist/HighchartsService';
import { FlexComponent } from './flex/flex';
import { MenuComponent } from './menu/menu';
import { CompanySideBarComponent } from './company-side-bar/company-side-bar';
import { SideSearchComponent } from './side-search/side-search';

import { CompanyAnalysisTableComponent } from './company-analysis-table/company-analysis-table';

import { HeroComponent } from './hero/hero';
import { MomentModule } from 'angular2-moment';
import { SegmentsComponent } from './segments/segments';
import { TopNavComponent } from './top-nav/top-nav';
import { SidebarHomeComponent } from './sidebar-home/sidebar-home';
import { SidebarScreensComponent } from './sidebar-screens/sidebar-screens';
import { SidebarWatchlistsComponent } from './sidebar-watchlists/sidebar-watchlists';
import { SidebarCoverageComponent } from './sidebar-coverage/sidebar-coverage';
import { FilterControlComponent } from './filter-control/filter-control';
import { WatchlistSearchResultsComponent } from './watchlist-search-results/watchlist-search-results';
import { ComparisonComponent } from './comparison/comparison';
import { SidebarComparisonComponent } from './sidebar-comparison/sidebar-comparison';
import { FlexControlComponent } from './flex-control/flex-control';
import { SharedModule } from './../app/shared/shared.module';
import { WwHeaderComponent } from './ww-header/ww-header';
import { TopFilterControlComponent } from './top-filter-control/top-filter-control';

declare var require: any;


export function highchartsFactory() {
  const hcm = require('highcharts/highcharts-more');
  const hc = require('highcharts');
  const dd = require('highcharts/modules/drilldown');
  const gauge = require('highcharts/modules/solid-gauge');
  const exporting = require('highcharts/modules/exporting');
  const oe = require('highcharts/modules/offline-exporting');
  hcm(hc);
  dd(hc);
  exporting(hc);
  oe(hc);
  gauge(hc);

  return hc;
}

@NgModule({
  declarations: [
    SectorEbitChartComponent,
    FlexComponent,
    MenuComponent,
    CompanySideBarComponent,
    SideSearchComponent,
    CompanyAnalysisTableComponent,
    HeroComponent,
    SegmentsComponent,
    TopNavComponent,
    SidebarHomeComponent,
    SidebarScreensComponent,
    SidebarWatchlistsComponent,
    SidebarCoverageComponent,
    FilterControlComponent,
    WatchlistSearchResultsComponent,
    ComparisonComponent,
    SidebarComparisonComponent,
    ChartComponent,
    FlexControlComponent,
    WwHeaderComponent,
    TopFilterControlComponent],
  imports: [IonicModule, ChartModule, MomentModule, SharedModule],
  exports: [
    SectorEbitChartComponent,
    FlexComponent,
    MenuComponent,
    CompanySideBarComponent,
    SideSearchComponent,
    CompanyAnalysisTableComponent,
    HeroComponent,
    SegmentsComponent,
    TopNavComponent,
    SidebarHomeComponent,
    SidebarScreensComponent,
    SidebarWatchlistsComponent,
    SidebarCoverageComponent,
    FilterControlComponent,
    WatchlistSearchResultsComponent,
    ComparisonComponent,
    SidebarComparisonComponent,
    ChartComponent,
    FlexControlComponent,
    WwHeaderComponent,
    TopFilterControlComponent
  ],
  providers: [
    {
      provide: HighchartsStatic,
      useFactory: highchartsFactory
    }
  ]
})
export class ComponentsModule { }



// WEBPACK FOOTER //
// ./src/components/components.module.ts